const maxScores = {
    "Leadership & Budgeting Availability": 28,
    "Organisation Technical Skill Set Questions": 12,
    "Treatment of Data": 32,
    "Machinery Capabilities": 20
}
const quizQuestions = {
    "Leadership & Budgeting Availability": [
        "Your company has a history of innovation in the past",
        "Digital transformation is a priority for your organization",
        "Management has a high level of understanding and capabilities when it comes to data",
        "Sufficient budget has been set aside for AI/Data Analytics project",
        "Leadership is committed to the success of AI/Data Analytics projects",
        "There is on-site personnel that is committed to championing Digital Transformation",
        "Your company has a good change management process implemented to ensure a smooth transition for any change in processes"
    ],
    "Organisation Technical Skill Set Questions": [
        "There are experts who understand which sensors and machines to connect to and what data can be extracted, ready to assist",
        "Solution providers have access to IT engineers for connecting sensor networks and data storage",
        "Organization has data scientists or engineers on hand that can interpret and utilize data analytics tools"
    ],
    "Treatment of Data": [
        "Data is stored digitally by your company",
        "Organization uses external cloud for data storage",
        "Data is widely accessible by an individual with proper credentials in your company (or external parties)",
        "Collected data is relevant to the product and line improvements which you are trying to make",
        "Data collected is of high quality, constantly maintained and up to date",
        "A clear system is in place to segregate sensitive collected data from non-sensitive data",
        "There are security protocols in place for each data source in your organisation",
        "Company decisions over product features or process upgrades are made in an evidence-based, data-driven manner"
    ],
    "Machinery Capabilities": [
        "Our key machines are equipped with sensors",
        "Our key machines are either network-ed or network accessible",
        "Machine downtimes are always captured by our system",
        "All key parts have serial numbers and/or batch numbers",
        "Part serial numbers or batch numbers with timestamps are captured at each process step"
    ]
};

function parseQuestions(questions) {
    let questionDict = {};
    Object.keys(questions).map((category, index) =>
        questions[category].forEach(question => (questionDict[question] = category))
    );
    return questionDict;
}

function parseResult(results, questionDict) {
    let parsedResults = {};
    Object.keys(results).map((key, index) => {
        let category = questionDict[key];
        if (!parsedResults.hasOwnProperty(category)) {
            parsedResults[category] = 0;
        }
        parsedResults[category] += parseInt(results[key]);
        return 0;
    });
    return parsedResults;
}

const reformattedQuiz = parseQuestions(quizQuestions);
export { quizQuestions, reformattedQuiz, parseResult, maxScores};
